import { passCodes } from '../passCodes';
import track38 from '../../../../assets/audio/tracks/track38.mp3';

const hints = [
    {
        text: 'Kódy byly: studna, pana marie s ježíškem, ostrve, hvězdy, W, kužely',
    },
    {
        text: 'Rozhlédněte se okolo sebe, najdete tu perfektní nápovědu od toho, kdo nyní nemá svůj hlas ale jinak byste ho nepřeslechli.',
    },
    {
        text: 'Jedná se o znak města Žďáru.',
    },
    {
        text: 'Kódem je: erb',
        solution: true,
    },
];
export const step38museum = {
    id: 36,
    title: '18. stanoviště',
    taskText: `
        <p>
            Koukni, už to vidím nad dveřmi. Víš ty, co to je? Tomu se říká ostrve a co jsem se ptal tak to jsou sukovitý kmeny s pahýly po větvích, prostě větve po zásahu drvoštěpa nebo perfektní hračka pro kočky. Hmm ale k čemu nám to bude? 
        </p>
        <p>
            Zkus se podívat, co nám vše, co jsme dnes viděli dává dohromady. Co to může být?
        </p>
    `,
    catImage: 7,
    cipher: {
        label: 'Úkol',
        text: `
            <p>
                Co se to tedy ve Žďáře ztratilo?   
            </p>
            <p>
                Doufám, že sis zapisoval všechny kódy, které si cestou zadával. Delfín nám to přece na začátku říkal. Dané kódy tvoří dohromady jednu z neodmyslitelných částí Žďáru.
            </p>
        `,
    },
    audio: track38,
    snowAudio: track38,
    codeInputText: 'Zadejte kód',
    codeInputPassCodeRegexp: passCodes[28],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
